/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RegistrazioneResDto } from '../../models/registrazione-res-dto';

export interface RegistrazioniControllerGetOneRegistrazioneById$Params {
  id: number;
}

export function registrazioniControllerGetOneRegistrazioneById(
  http: HttpClient,
  rootUrl: string,
  params: RegistrazioniControllerGetOneRegistrazioneById$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<RegistrazioneResDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    registrazioniControllerGetOneRegistrazioneById.PATH,
    'get',
  );
  if (params) {
    rb.path('id', params.id, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RegistrazioneResDto>;
      }),
    );
}

registrazioniControllerGetOneRegistrazioneById.PATH =
  '/admin/registrazione/id/{id}';
